// import React from "react";
// import { logoHeader } from "../assets/images/image";

// type HeaderProps = {
//     pathname: string;
// };

// export default function Header({ pathname }: HeaderProps) {
//     const [active, setActive] = React.useState(pathname);

//     const menuItems = [
//         { id: "/", label: "Home" },
//         { id: "/contact", label: "Contact" },
//     ];

//     return (
//         <>
//             {/* Desktop Layout */}
//             <header className="hidden md:flex relative w-full items-center">
//                 <img
//                     src={logoHeader}
//                     alt="Logo"
//                     className="h-[36px] absolute left-0 top-0 cursor-pointer"
//                     onClick={() => window.location.href = '/'}
//                 />
//                 <div className="mx-auto flex space-x-[128px] mt-[8px]">
//                     {menuItems.map((item) => (
//                         <button
//                             key={item.id}
//                             onClick={() => {
//                                 setActive(item.id);
//                                 window.location.href = item.id;
//                             }}
//                             className={`relative text-[16px] leading-[normal]
//                                 ${active === item.id ? "df-color font-bold" : "text-[#484848] font-normal"}`}
//                         >
//                             {item.label}
//                             {active === item.id && (
//                                 <span className="absolute -bottom-[20px] left-1/2 transform -translate-x-1/2 w-[28.518px] h-1 rounded-[16px] bg-[#3A57FF]" />
//                             )}
//                         </button>
//                     ))}
//                 </div>
//             </header>

//             {/* Mobile Layout - Fixed on top */}
//             <header className="md:hidden relative w-full">
//                 <div className="md:hidden relative top-[50px] flex items-center justify-center w-full flex-col">
//                     <img
//                         src={logoHeader}
//                         alt="Logo"
//                         className="cursor-pointer h-[24px]"
//                         onClick={() => window.location.href = '/'}
//                     />
//                     <div className="flex mt-[24px] space-x-[64px]">
//                         {menuItems.map((item) => (
//                             <button
//                                 key={item.id}
//                                 onClick={() => {
//                                     setActive(item.id);
//                                     window.location.href = item.id;
//                                 }}
//                                 className={`relative text-[16px] leading-[normal]
//                                     ${active === item.id ? "df-color font-bold" : "text-[#484848] font-normal"}`}
//                             >
//                                 {item.label}
//                                 {active === item.id && (
//                                     <span className="absolute -bottom-[8px] left-1/2 transform -translate-x-1/2 w-[28.518px] h-1 rounded-[16px] bg-[#3A57FF]" />
//                                 )}
//                             </button>
//                         ))}
//                     </div>
//                 </div>
//             </header>
//         </>
//     );
// }


import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { logoHeader } from "../assets/images/image";
import { APP_URL } from "../configs/default.config";

type HeaderProps = {
    pathname: string;
};

export default function Header({ pathname }: HeaderProps) {
    const { t, i18n } = useTranslation();
    const [scrolled, setScrolled] = React.useState(false);
    const [langOpen, setLangOpen] = React.useState(false);
    const langWrapRefDesktop = React.useRef<HTMLDivElement | null>(null);
    const langWrapRefMobile = React.useRef<HTMLDivElement | null>(null);

    React.useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const menuItems = [
        { id: "/", labelKey: "nav.home" },
        { id: "/use-cases", labelKey: "nav.useCases" },
        { id: "/pricing", labelKey: "nav.pricing" },
        { id: "/contact", labelKey: "nav.contact" },
    ];

    const changeLanguage = (lng: "en" | "vi") => {
        localStorage.setItem("i18nextLng", lng);
        i18n.changeLanguage(lng);
        setLangOpen(false);
    };

    const isActive = (itemId: string) => {
        if (itemId === "/") return pathname === "/";
        return pathname === itemId || pathname.startsWith(itemId + "/");
    };

    const currentLang = (i18n.language || "en").startsWith("vi") ? "vi" : "en";

    React.useEffect(() => {
        const onDocMouseDown = (e: MouseEvent) => {
            const target = e.target as Node | null;
            if (!target) return;
            const inDesktop = !!langWrapRefDesktop.current?.contains(target);
            const inMobile = !!langWrapRefMobile.current?.contains(target);
            if (!inDesktop && !inMobile) setLangOpen(false);
        };
        document.addEventListener("mousedown", onDocMouseDown);
        return () => document.removeEventListener("mousedown", onDocMouseDown);
    }, []);

    const Flag = ({ code }: { code: "en" | "vi" }) => {
        // Inline SVG flags to avoid adding new assets.
        if (code === "vi") {
            return (
                <span className="inline-flex w-6 h-6 rounded-full overflow-hidden items-center justify-center bg-[#DA251D]">
                    <svg width="24" height="24" viewBox="0 0 18 12" aria-hidden="true">
                        <rect width="18" height="12" fill="#DA251D" />
                        <path
                            d="M9 2.1 10.2 5.2 13.5 5.2 10.8 7 11.8 10 9 8.2 6.2 10 7.2 7 4.5 5.2 7.8 5.2Z"
                            fill="#FF0"
                        />
                    </svg>
                </span>
            );
        }
        // UK-ish flag (simplified)
        return (
            <span className="inline-flex w-6 h-6 rounded-full overflow-hidden items-center justify-center bg-[#012169]">
                <svg width="24" height="24" viewBox="0 0 18 12" aria-hidden="true">
                    <rect width="18" height="12" fill="#012169" />
                    <path d="M0 0 18 12M18 0 0 12" stroke="#FFF" strokeWidth="2.6" />
                    <path d="M0 0 18 12M18 0 0 12" stroke="#C8102E" strokeWidth="1.4" />
                    <path d="M9 0V12M0 6H18" stroke="#FFF" strokeWidth="4" />
                    <path d="M9 0V12M0 6H18" stroke="#C8102E" strokeWidth="2.2" />
                </svg>
            </span>
        );
    };

    const ArrowRight = () => (
        <svg width="16" height="16" viewBox="0 0 20 20" aria-hidden="true">
            <path
                d="M11.2 4.3a1 1 0 0 1 1.4 0l5 5a1 1 0 0 1 0 1.4l-5 5a1 1 0 1 1-1.4-1.4l3.3-3.3H3a1 1 0 1 1 0-2h11.5l-3.3-3.3a1 1 0 0 1 0-1.4Z"
                fill="currentColor"
            />
        </svg>
    );

    return (
        <>
            {/* Desktop Layout */}
            <header className="hidden md:flex relative w-full flex items-center">
                <img
                    src={logoHeader}
                    alt="Logo"
                    className="h-[36px] absolute left-0 top-0 cursor-pointer"
                    onClick={() => window.location.href = '/'}
                />
                <div className="mx-auto flex items-center space-x-[128px] mt-[8px] top-0">
                    {menuItems.map((item) => (
                        <Link
                            key={item.id}
                            to={item.id}
                            className={`relative text-[16px] leading-[normal]
                        ${isActive(item.id) ? "df-color font-bold" : "text-[#484848] font-normal"}`}
                        >
                            {t(item.labelKey)}
                            {isActive(item.id) && (
                                <span className="absolute -bottom-[20px] left-1/2 transform -translate-x-1/2 w-[28.518px] h-1 flex-shrink-0 rounded-[16px] bg-[#3A57FF]" />
                            )}
                        </Link>
                    ))}
                </div>
                <div className="absolute right-0 top-0 flex items-center gap-4">
                    <button
                        type="button"
                        onClick={() => window.location.href = APP_URL}
                        className="inline-flex h-[36px] px-5 items-center justify-center gap-2 rounded-full bg-[#3A57FF] text-white text-[14px] font-medium"
                    >
                        <span className="whitespace-nowrap">{t("header.startUsingApp")}</span>
                        <ArrowRight />
                    </button>

                    <div ref={langWrapRefDesktop} className="relative">
                        <button
                            type="button"
                            onClick={() => setLangOpen((v) => !v)}
                            className="inline-flex items-center gap-2 rounded-full px-3 py-2 hover:bg-[#F2F2F2] transition"
                            aria-haspopup="menu"
                            aria-expanded={langOpen}
                        >
                            <Flag code={currentLang} />
                            <span className="text-[14px] text-[#494949] font-medium">
                                {currentLang === "en" ? t("common.en") : t("common.vi")}
                            </span>
                        </button>

                        {langOpen && (
                            <div
                                role="menu"
                                className="absolute right-0 mt-2 w-[170px] rounded-[12px] bg-white shadow-lg border border-[#E6E6E6] overflow-hidden"
                            >
                                <button
                                    type="button"
                                    role="menuitem"
                                    onClick={() => changeLanguage("en")}
                                    className="w-full flex items-center gap-3 px-3 py-2 hover:bg-[#F7F7F7] text-left"
                                >
                                    <Flag code="en" />
                                    <span className="text-[14px] text-[#494949]">{t("common.en")}</span>
                                </button>
                                <button
                                    type="button"
                                    role="menuitem"
                                    onClick={() => changeLanguage("vi")}
                                    className="w-full flex items-center gap-3 px-3 py-2 hover:bg-[#F7F7F7] text-left"
                                >
                                    <Flag code="vi" />
                                    <span className="text-[14px] text-[#494949]">{t("common.vi")}</span>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </header>

            {/* Mobile Layout */}
            <header className="md:hidden relative w-full">
                <div
                    className={`md:hidden fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md py-3' : 'bg-white/95 py-4'} `}
                >
                    <div className="px-4">
                        <div className="relative flex items-center justify-center">
                            <img
                                src={logoHeader}
                                alt="Logo"
                                className={`cursor-pointer transition-all duration-300 ${scrolled ? 'h-[20px]' : 'h-[24px]'}`}
                                onClick={() => window.location.href = '/'}
                            />
                            <div ref={langWrapRefMobile} className="absolute right-0 top-1/2 -translate-y-1/2">
                                <button
                                    type="button"
                                    onClick={() => setLangOpen((v) => !v)}
                                    className="inline-flex items-center justify-center rounded-full p-1"
                                    aria-haspopup="menu"
                                    aria-expanded={langOpen}
                                >
                                    <Flag code={currentLang} />
                                </button>

                                {langOpen && (
                                    <div
                                        role="menu"
                                        onMouseDown={(e) => e.stopPropagation()}
                                        onClick={(e) => e.stopPropagation()}
                                        className="absolute right-0 mt-2 w-[150px] rounded-[14px] bg-white shadow-lg border border-[#E6E6E6] overflow-hidden z-[120]"
                                    >
                                        <button
                                            type="button"
                                            role="menuitem"
                                            onMouseDown={(e) => e.stopPropagation()}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                changeLanguage("en");
                                            }}
                                            className="w-full flex items-center gap-3 px-3 py-2 hover:bg-[#F7F7F7] text-left"
                                        >
                                            <Flag code="en" />
                                            <span className="text-[13px] text-[#494949] whitespace-nowrap">{t("common.en")}</span>
                                        </button>
                                        <button
                                            type="button"
                                            role="menuitem"
                                            onMouseDown={(e) => e.stopPropagation()}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                changeLanguage("vi");
                                            }}
                                            className="w-full flex items-center gap-3 px-3 py-2 hover:bg-[#F7F7F7] text-left"
                                        >
                                            <Flag code="vi" />
                                            <span className="text-[13px] text-[#494949] whitespace-nowrap">{t("common.vi")}</span>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className={`mt-3 grid grid-cols-4 gap-2 transition-all duration-300 ${scrolled ? 'scale-95' : 'scale-100'}`}>
                            {menuItems.map((item) => (
                                <Link
                                    key={item.id}
                                    to={item.id}
                                    className={`relative text-[13px] leading-[1.15] text-center min-h-[38px] flex items-start justify-center
                                        ${isActive(item.id) ? "df-color font-bold" : "text-[#484848] font-normal"}`}
                                >
                                    {t(item.labelKey)}
                                    {isActive(item.id) && (
                                        <span className="absolute -bottom-[8px] left-1/2 transform -translate-x-1/2 w-[28.518px] h-1 flex-shrink-0 rounded-[16px] bg-[#3A57FF]" />
                                    )}
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
                {/* Spacer to account for fixed header height */}
                <div className="h-[96px] md:hidden"></div>
            </header>
        </>
    );
}